let IS_PRODUCTION = true;

export const SettingsURL = IS_PRODUCTION
  ? "https://backend.redi-home.com/api"
  : "http://localhost:8000/api";
export const BackendImageURL =
  "https://redihomecdn.fra1.cdn.digitaloceanspaces.com";
